var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 63,
    viewBox: "0 0 121 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_388_6539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 22,
    width: 121,
    height: 19
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_388_6539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4673 22.3447H17.1348V40.4662H22.4673V22.3447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7129 40.4662H40.5026V36.866H32.0454V33.1625H39.4667V29.6657H32.0454V25.9449H40.5026V22.3447H26.7129V40.4662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0894 33.1108L50.3853 22.3447H43.4395V40.4662H47.719V29.6657L52.4232 40.4662H55.9216L60.9823 29.3901V40.4662H66.3148V22.3447H59.9973L55.0894 33.1108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.179 33.4726L93.4879 22.3447H87.6289V40.4662H91.399V29.2867L98.1411 40.4662H103.949V22.3447H100.179V33.4726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5098 40.4662H84.2995V36.866H75.8423V33.1625H83.2636V29.6657H75.8423V25.9449H84.2995V22.3447H70.5098V40.4662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3774 30.6647C9.86591 29.9757 7.50535 28.7527 5.89202 28.0119C4.3636 27.3229 4.32963 23.6711 13.1096 26.3755V22.9304C11.2755 22.293 6.26563 21.07 2.49553 23.1887C-1.27458 25.3075 -0.374507 30.5614 2.49553 32.3012C3.75223 32.9902 5.46746 33.6275 7.67518 34.575C9.4923 35.3673 10.5962 39.3982 0.202897 36.642V40.1906C2.34269 40.9829 10.1886 41.827 12.4812 39.2431C15.3512 36.0047 14.0436 31.7844 11.3774 30.6647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.282 30.6647C116.77 29.9757 114.41 28.7527 112.796 28.0119C111.268 27.3229 111.234 23.6711 120.014 26.3755V22.9304C118.18 22.293 113.17 21.07 109.4 23.1887C105.63 25.3075 106.53 30.5614 109.4 32.3012C110.657 32.9902 112.372 33.6275 114.579 34.575C116.397 35.3673 117.5 39.3982 107.107 36.642V40.1906C109.247 40.9829 117.093 41.827 119.386 39.2431C122.256 36.0047 120.948 31.7844 118.282 30.6647Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_388_6539)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 63,
    fill: "#B3BACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_388_6539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 19,
    fill: "white",
    transform: "translate(0 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner5);
export default __webpack_public_path__ + "static/media/partner-5.e8140ac70d7c850171fb28857703ba23.svg";
export { ForwardRef as ReactComponent };